"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormInputClearable = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactUforms = require("react-uforms");

var _input = require("./input");

var _input2 = require("./input.styled");

var _close = _interopRequireDefault(require("../../../icons/close"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var FormInputClearable = function FormInputClearable(_ref) {
  var onClear = _ref.onClear,
      props = _objectWithoutProperties(_ref, ["onClear"]);

  return /*#__PURE__*/_react.default.createElement(_reactUforms.CustomField, {
    name: props.name,
    hideError: true
  }, function (_ref2) {
    var setValue = _ref2.setValue,
        getValue = _ref2.getValue,
        setTouched = _ref2.setTouched;
    return /*#__PURE__*/_react.default.createElement(_input2.FormInputWrapStyled, null, /*#__PURE__*/_react.default.createElement(_input.FormInput, _extends({
      clearable: true,
      onBlur: function onBlur() {
        return setTouched();
      }
    }, props)), getValue() && getValue().length > 0 && /*#__PURE__*/_react.default.createElement(_input2.FormInputClearStyled, {
      onClick: function onClick() {
        if (onClear) {
          onClear();
        }

        setValue('');
      }
    }, /*#__PURE__*/_react.default.createElement(_close.default, {
      measure: 10,
      color: "black"
    })));
  });
};

exports.FormInputClearable = FormInputClearable;
FormInputClearable.defaultProps = {
  type: 'text'
};
FormInputClearable.displayName = 'FormInputClearable';